export const INK   = '#000000';
export const PAPER = '#ffffff';
export const RULE  = '#000000';
export const RULE_THIN = '0.3pt solid #000000';
export const RULE_MED  = '1px solid #000000';
